/* eslint-disable max-params */
import {DataObjectId, Hub} from 'yougile-model'
import {Sync} from '@client/sync'
import {PageService} from '@extensions/page-service'
import {Sticker} from '@extensions/sticker/sticker'
import {OrderSubMenuActionType} from './types'

export const sortByCustomSticker = (
  tasks: Hub[],
  action: OrderSubMenuActionType,
  stickerId: DataObjectId,
  numeric?: boolean
): Hub[] => {
  const board = PageService.getCurrentBoard()
  const box = Sync.get(board)
  const tag = Sticker.getById(box, stickerId)
  const order = tag?.states.order

  return tasks.sort((b, a) => {
    const aValue = a.stickers[stickerId]
    const bValue = b.stickers[stickerId]

    if (aValue && bValue) {
      if (numeric) {
        const aValueNumber = Number(aValue)
        const bValueNumber = Number(bValue)

        return action === 'az'
          ? bValueNumber - aValueNumber
          : aValueNumber - bValueNumber
      }

      if (order) {
        const idxA = order.indexOf(aValue)
        const idxB = order.indexOf(bValue)

        if (action === 'az') {
          return idxA - idxB
        } else {
          return idxB - idxA
        }
      }
    }

    if (aValue) {
      return 1
    }

    if (!aValue && !bValue) {
      return 0
    }

    return -1
  })
}

export const sortByStickerName = (
  tasks: Hub[],
  action: OrderSubMenuActionType,
  stickerId: string
): Hub[] => {
  return tasks.sort((a, b) => {
    const aValue = a.stickers[stickerId]
    const bValue = b.stickers[stickerId]

    if (aValue && bValue) {
      return action === 'az'
        ? aValue.localeCompare(bValue)
        : bValue.localeCompare(aValue)
    }

    if (aValue) {
      return -1
    }

    if (!aValue && !bValue) {
      return 0
    }

    return 1
  })
}
